<!--div *ngIf="isLoaded()"-->
<div class="" *ngIf="isLoaded()" cdkTrapFocus>
  <sub-header [includeContextHelp]="true" [isModal]="true" [windowHash]=windowHash>
  </sub-header>
  <!--dossierHeader [projectId]="project.identifier" [infoVisible]="false" [favouriteVisible]="false" [backVisible]="false"></dossierHeader>
  <div class="buttonsHeader">
    <button pButton type="button" label="Validar" icon="fa far fa-question-circle" class="p-button-warning" (click)="validate()"></button>
    <button pButton type="button" label="Guardar" icon="pi pi-check" (click)="updateAward(award)"></button>
  </div-->
  <div class="row">
    <div class="col-12">
      <upload-files [files]="[]" (deleteItem)="deleteFileItem($event)" (addItem)="addFileItem($event)" tabindex="7">
      </upload-files>
    </div>
  </div>
</div>
<!--/div-->